












































































































































import Vue from 'vue'

export default Vue.extend({
  name: 'ScoreExplained',
  props: {
    type: {
      type: String,
      default: 'global',
      validator (value: string): boolean {
        return ['global', 'homonym', 'id'].includes(value)
      }
    }
  },
  computed: {
    title () {
      switch (this.type) {
        case 'global': {
          return this.$t('Puntaje global')
        }
        case 'homonym': {
          return this.$t('Puntaje por nombre')
        }
        case 'id': {
          return this.$t('Puntaje por ID')
        }
      }

      return ''
    }
  },
  methods: {
    emitShowMoreInformation () {
      this.$emit('close-more-information', false)
    }
  }
})
